import { Pipe, PipeTransform } from "@angular/core";
import { TrackDataModel } from "../../model";

@Pipe({
    name: 'statusFilter',
    standalone: false
})
export class StatusFilterPipe implements PipeTransform {

    transform(tracksDataList: TrackDataModel[], statusId: number): any {
        if (tracksDataList) {
            return tracksDataList.filter((track: TrackDataModel, idx: number, obj: TrackDataModel[]) => {
                return statusId === 0 || track?.status_id === statusId;
            });
        }

        return tracksDataList;
    }

}